import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _cloneDeep from "lodash/cloneDeep";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es7.object.values.js";
import "core-js/modules/es6.object.keys.js";
import dayjs from 'dayjs';
import { SAMPLES_CREATED, SAMPLES_ERROR, SAMPLES_SAVED, SAMPLES_SAVING } from 'redux/actionTypes/samples';
import fetchAPI from 'utils/http/fetchAPI';
import handleError from 'utils/http/handleError';
import endUserMessages from 'utils/endUserMessages';
import { METADATA_DEFAULT_VALUE } from 'redux/reducers/experiments/initialState';
import { defaultSampleOptions, sampleTemplate } from 'redux/reducers/samples/initialState';
import { sampleTech } from 'utils/constants';
import UploadStatus from 'utils/upload/UploadStatus';

// If the sample name of new samples coincides with already existing
// ones we should not create new samples,
// just reuse their sampleIds and upload the new files
var splitByAlreadyExistingSamples = function splitByAlreadyExistingSamples(newSamples, sampleIds, samples, sampleTechnology, options, kit) {
  var alreadyCreatedSampleIds = {};
  sampleIds.forEach(function (sampleId) {
    var _newSamples$find;
    var _ref = (_newSamples$find = newSamples.find(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 1),
          name = _ref4[0];
        return name === samples[sampleId].name;
      })) !== null && _newSamples$find !== void 0 ? _newSamples$find : [],
      _ref2 = _slicedToArray(_ref, 1),
      _ref2$ = _ref2[0],
      repeatedSampleName = _ref2$ === void 0 ? null : _ref2$;
    if (!repeatedSampleName) return;
    alreadyCreatedSampleIds[repeatedSampleName] = sampleId;
  });
  var samplesToCreate = newSamples
  // Upload only the samples that don't have a repeated name
  .filter(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 1),
      name = _ref6[0];
    return !alreadyCreatedSampleIds[name];
  }).map(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 1),
      name = _ref8[0];
    return {
      name: name,
      sampleTechnology: sampleTechnology,
      options: options,
      kit: kit
    };
  });
  return {
    samplesToCreate: samplesToCreate,
    alreadyCreatedSampleIds: alreadyCreatedSampleIds
  };
};
var createSamples = function createSamples(experimentId, newSamples, sampleTechnology) {
  return /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var experiment, _getState, samples, createdDate, options, kit, _firstSampleId, _splitByAlreadyExisti, samplesToCreate, alreadyCreatedSampleIds, url, _newSampleIdsByName, _sampleIdsByName, _newSamplesToRedux, _errorMessage;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch({
                type: SAMPLES_SAVING,
                payload: {
                  message: endUserMessages.SAVING_SAMPLE
                }
              });
              experiment = getState().experiments[experimentId];
              _getState = getState(), samples = _getState.samples;
              createdDate = dayjs().toISOString();
              if (Object.values(sampleTech).includes(sampleTechnology)) {
                _context.next = 6;
                break;
              }
              throw new Error("Sample technology ".concat(sampleTechnology, " is not recognized"));
            case 6:
              options = defaultSampleOptions[sampleTechnology] || {};
              kit = null; // If there are other samples in the same experiment, use the options and kit
              // values from the other samples
              if (experiment.sampleIds.length) {
                _firstSampleId = experiment.sampleIds[0];
                options = samples[_firstSampleId].options;
                kit = samples[_firstSampleId].kit;
              }
              _splitByAlreadyExisti = splitByAlreadyExistingSamples(newSamples, experiment.sampleIds, samples, sampleTechnology, options, kit), samplesToCreate = _splitByAlreadyExisti.samplesToCreate, alreadyCreatedSampleIds = _splitByAlreadyExisti.alreadyCreatedSampleIds;
              if (!(samplesToCreate.length === 0)) {
                _context.next = 13;
                break;
              }
              dispatch({
                type: SAMPLES_SAVED
              });
              return _context.abrupt("return", alreadyCreatedSampleIds);
            case 13:
              url = "/v2/experiments/".concat(experimentId, "/samples");
              _context.prev = 14;
              _context.next = 17;
              return fetchAPI(url, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(samplesToCreate)
              });
            case 17:
              _newSampleIdsByName = _context.sent;
              // Join the already existing sampleIds with the new ones,
              // order is preserved in newSamples
              _sampleIdsByName = _objectSpread(_objectSpread({}, alreadyCreatedSampleIds), _newSampleIdsByName);
              _newSamplesToRedux = newSamples
              // Remove repeated samples
              .filter(function (_ref10) {
                var _ref11 = _slicedToArray(_ref10, 1),
                  name = _ref11[0];
                return _newSampleIdsByName[name];
              }).map(function (_ref12) {
                var _experiment$metadataK;
                var _ref13 = _slicedToArray(_ref12, 2),
                  name = _ref13[0],
                  files = _ref13[1].files;
                return _objectSpread(_objectSpread({}, _cloneDeep(sampleTemplate)), {}, {
                  name: name,
                  type: sampleTechnology,
                  experimentId: experimentId,
                  uuid: _sampleIdsByName[name],
                  createdDate: createdDate,
                  lastModified: createdDate,
                  options: options,
                  metadata: (_experiment$metadataK = experiment === null || experiment === void 0 ? void 0 : experiment.metadataKeys.reduce(function (acc, metadataKey) {
                    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, metadataKey, METADATA_DEFAULT_VALUE));
                  }, {})) !== null && _experiment$metadataK !== void 0 ? _experiment$metadataK : {},
                  files: Object.keys(files).reduce(function (acc, fileType) {
                    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, fileType, {
                      upload: {
                        status: UploadStatus.UPLOADING
                      }
                    }));
                  }, {})
                });
              });
              dispatch({
                type: SAMPLES_CREATED,
                payload: {
                  experimentId: experimentId,
                  samples: _newSamplesToRedux
                }
              });
              dispatch({
                type: SAMPLES_SAVED
              });
              return _context.abrupt("return", _sampleIdsByName);
            case 25:
              _context.prev = 25;
              _context.t0 = _context["catch"](14);
              _errorMessage = handleError(_context.t0, endUserMessages.ERROR_CREATING_SAMPLE);
              dispatch({
                type: SAMPLES_ERROR,
                payload: {
                  error: _errorMessage
                }
              });

              // throw again the error so `processSampleUpload` won't upload the sample
              throw new Error(_errorMessage);
            case 30:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[14, 25]]);
    }));
    return function (_x, _x2) {
      return _ref9.apply(this, arguments);
    };
  }();
};
export default createSamples;